export default __webpack_public_path__ + "static/media/sie-intranet-black-rgb.b09d3589.svg";